module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.aa4568c4.svg";